// extracted by mini-css-extract-plugin
export var button = "partnerSection-module--button--ef138";
export var comment = "partnerSection-module--comment--69b57";
export var image = "partnerSection-module--image--7d581";
export var name = "partnerSection-module--name--abddd";
export var quote = "partnerSection-module--quote--781da";
export var subQuote = "partnerSection-module--subQuote--7eacd";
export var wrapper = "partnerSection-module--wrapper--6670c";